import { render, staticRenderFns } from "./label-container.vue?vue&type=template&id=b8d04226"
import script from "./label-container.vue?vue&type=script&lang=ts"
export * from "./label-container.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports